function hasValue(obj) {
    return (obj != null &&
        (typeof obj !== "undefined") &&
        obj !== "");
}
export default hasValue;
//# sourceMappingURL=hasValue.js.map